export const REQUISICAO_STATUS_LABELS = {
  AGUARDANDO: 'Aguardando',
  EM_ANALISE: 'Em análise',
  PARCIALMENTE_APROVADA: 'Parcialmente aprovada',
  APROVADA: 'Aprovada',
  REJEITADA: 'Rejeitada',
  EXECUTANDO: 'Em execução',
  FINALIZADA: 'Finalizada',
  CONCLUIDA: 'Concluída',
  CANCELADA: 'Cancelada',
};

export const REQUISICAO_STATUS_HELP = {
  AGUARDANDO: 'Ainda há item pendente de decisão na aba Itens.',
  EM_ANALISE: 'A requisição está em revisão.',
  PARCIALMENTE_APROVADA: 'Parte dos itens já foi decidida. Ainda há item pendente.',
  APROVADA: 'A decisão dos itens fechou e ainda não existe entrega.',
  REJEITADA: 'Nenhum item será atendido.',
  EXECUTANDO: 'A entrega já começou. Despacho e conclusão ficam na aba Entregas.',
  FINALIZADA: 'Não falta entrega nem pedido em aberto.',
  CONCLUIDA: 'Não falta entrega nem pedido em aberto.',
  CANCELADA: 'A requisição foi cancelada.',
};

export const REQUISICAO_ITEM_STATUS_LABELS = {
  PENDENTE: 'Pendente',
  APROVADO: 'Aprovado',
  REJEITADO: 'Rejeitado',
  PARA_PEDIDO: 'Para pedido',
  ENVIADO: 'Enviado',
  ENTREGUE: 'Entregue',
  CANCELADO: 'Cancelado',
};

export const ENTREGA_STATUS_LABELS = {
  PREPARANDO: 'Preparando',
  ENVIADO: 'Em trânsito',
  ENTREGUE: 'Entregue',
  CANCELADA: 'Cancelada',
};

export const PEDIDO_STATUS_LABELS = {
  PENDENTE: 'Pendente',
  ENVIADO: 'Enviado',
  RECEBIDO: 'Recebido',
  CANCELADO: 'Cancelado',
};

export const TIPO_ITEM_LABELS = {
  EQUIPAMENTO: 'Equipamento',
  PRODUTO: 'Produto',
  VEICULO: 'Veículo',
};

export const TIPO_ENTREGA_OPTIONS = [
  { id: 'TRANSPORTADORA', nome: 'Transportadora' },
  { id: 'COLABORADOR', nome: 'Colaborador' },
  { id: 'RETIRADA', nome: 'Retirada' },
];

export const MOTIVO_SOLICITACAO_OPTIONS = [
  { id: 'NOVO', nome: 'Novo' },
  { id: 'TROCA', nome: 'Troca' },
];

export const MOTIVO_SOLICITACAO_LABELS = {
  NOVO: 'Novo',
  TROCA: 'Troca',
};

export const TAMANHO_OPTIONS = [
  { id: 'P', nome: 'P' },
  { id: 'M', nome: 'M' },
  { id: 'G', nome: 'G' },
  { id: 'GG', nome: 'GG' },
  { id: 'XGG', nome: 'XGG' },
];

export const DECISAO_ITEM_OPTIONS = [
  { id: 'APROVADO', nome: 'Aprovar' },
  { id: 'REJEITADO', nome: 'Rejeitar' },
  { id: 'PARA_PEDIDO', nome: 'Para pedido' },
];

export const DECISAO_ITEM_HELP = {
  APROVADO: 'Atender com o estoque. O item segue para entrega.',
  REJEITADO: 'Não atender. Motivo obrigatório; o solicitante vê no app.',
  PARA_PEDIDO: 'Não usar o estoque atual. Cria um pedido de almoxarifado ligado a este item.',
};

export const isItemOutro = (item) => {
  const idItem = String(item?.idItem || '').toUpperCase();
  if (idItem === 'OUTRO') return true;
  const nome = String(item?.nomeItem || '').trim();
  return /^outro(\s|\(|$)/i.test(nome);
};

export const REQUISICAO_STATUS_ORDER = [
  'AGUARDANDO',
  'EM_ANALISE',
  'PARCIALMENTE_APROVADA',
  'APROVADA',
  'REJEITADA',
  'EXECUTANDO',
  'FINALIZADA',
  'CONCLUIDA',
  'CANCELADA',
];

export const normalizeRequisicaoStatus = (status) => {
  if (status === 'RASCUNHO' || status === 'ENVIADO') return 'AGUARDANDO';
  return status;
};

export const isRequisicaoAguardando = (status) =>
  normalizeRequisicaoStatus(status) === 'AGUARDANDO';

export const isRequisicaoCriador = (requisicao, userId, userName) => {
  const ownerId = requisicao?.solicitanteId || requisicao?.solicitante?.id || null;
  if (ownerId && userId) return String(ownerId) === String(userId);
  if (ownerId) return false;
  const ownerName = String(requisicao?.solicitanteNome || '').trim().toLowerCase();
  const mine = String(userName || '').trim().toLowerCase();
  return !!ownerName && ownerName === mine;
};

export const getRequisicaoStatusLabel = (status) =>
  REQUISICAO_STATUS_LABELS[normalizeRequisicaoStatus(status)] || status || '—';

export const getItemStatusLabel = (status) =>
  REQUISICAO_ITEM_STATUS_LABELS[status] || status || '—';

export const getEntregaStatusLabel = (status) =>
  ENTREGA_STATUS_LABELS[status] || status || '—';

export const getPedidoStatusLabel = (status) =>
  PEDIDO_STATUS_LABELS[status] || status || '—';

export const ITEM_DECISAO_STATUSES = ['APROVADO', 'REJEITADO', 'PARA_PEDIDO'];

export const isRequisicaoTerminal = (status) =>
  status === 'FINALIZADA' || status === 'CONCLUIDA' || status === 'CANCELADA';

export const canDecidirItens = (status) => !isRequisicaoTerminal(status);

export const getRequisicaoItems = (requisicao) =>
  requisicao?.items || requisicao?.itens || [];

export const getItemPedidoCompra = (item, pedidos = []) => {
  if (!item) return null;
  if (item.pedidoId) {
    return pedidos.find((pedido) => pedido.id === item.pedidoId) || { id: item.pedidoId };
  }
  return (pedidos || []).find(
    (pedido) => Array.isArray(pedido.itemIds) && pedido.itemIds.includes(item.id)
  ) || null;
};

const normalizeTipoPedido = (pedido) => {
  const raw = String(pedido?.tipo || pedido?.tipoPedido || '').toUpperCase();
  if (raw === 'SAIDA' || raw === 'SAÍDA') return 'SAIDA';
  return 'ENTRADA';
};

const itemMatchesPedido = (item, pedido) => {
  if (!item || !pedido) return false;
  if (item.pedidoId && item.pedidoId === pedido.id) return true;
  if (item.pedidoEstoqueId && item.pedidoEstoqueId === pedido.id) return true;
  return Array.isArray(pedido.itemIds) && pedido.itemIds.includes(item.id);
};

export const getRequisicaoPedidosAlmoxarifado = (requisicao) => {
  const items = getRequisicaoItems(requisicao);
  const listed = (requisicao?.pedidos || []).map((pedido) => {
    const tipoPedido = normalizeTipoPedido(pedido);
    const ligados = items.filter((item) => itemMatchesPedido(item, pedido));
    return {
      ...pedido,
      tipoPedido,
      produtoNome: pedido.produtoNome || (ligados[0] && ligados[0].nomeItem) || null,
      quantidade: pedido.quantidade != null
        ? pedido.quantidade
        : (ligados[0] && ligados[0].quantidade),
      local: pedido.local || (ligados[0] && (tipoPedido === 'SAIDA' ? ligados[0].origem : ligados[0].local)) || null,
    };
  });
  const listedIds = new Set(listed.map((pedido) => pedido.id).filter(Boolean));
  const saidas = [];
  items.forEach((item) => {
    if (!item.pedidoEstoqueId || listedIds.has(item.pedidoEstoqueId)) return;
    listedIds.add(item.pedidoEstoqueId);
    saidas.push({
      id: item.pedidoEstoqueId,
      tipoPedido: 'SAIDA',
      numero: item.pedidoEstoqueNumero || null,
      local: item.origem || null,
      produtoNome: item.nomeItem,
      quantidade: item.quantidade,
      itemIds: [item.id],
    });
  });
  return [...listed, ...saidas];
};

export const canAlterarItem = (item, requisicao) => {
  if (!item || isRequisicaoTerminal(requisicao?.status)) return false;
  if (!ITEM_DECISAO_STATUSES.includes(item.status)) return false;
  if (item.entregaId) return false;
  return true;
};

export const hasItensPendentes = (requisicao) =>
  getRequisicaoItems(requisicao).some((item) => item.status === 'PENDENTE');

export const isItemElegivelEntrega = (item) =>
  !!item
  && !item.entregaId
  && (item.status === 'APROVADO' || item.status === 'PARA_PEDIDO');

export const hasAprovadosSemEntrega = (requisicao) =>
  getRequisicaoItems(requisicao).some(isItemElegivelEntrega);

export const canCriarRequisicaoEntrega = (requisicao) =>
  hasAprovadosSemEntrega(requisicao) && !hasItensPendentes(requisicao);

const countLabel = (count, singular, plural) =>
  `${count} ${count === 1 ? singular : plural}`;

export const getEntregaAtencao = (requisicao) => {
  const entregas = requisicao?.entregas || [];
  const preparando = entregas.filter((entrega) => entrega.status === 'PREPARANDO').length;
  const transito = entregas.filter((entrega) => entrega.status === 'ENVIADO').length;
  const semEntrega = canCriarRequisicaoEntrega(requisicao);
  if (!preparando && !transito && !semEntrega) return null;
  const parts = [];
  if (semEntrega) parts.push('Há itens aprovados sem entrega.');
  if (preparando) {
    parts.push(`Há ${countLabel(preparando, 'entrega para despachar', 'entregas para despachar')}.`);
  }
  if (transito) {
    parts.push(`Há ${countLabel(transito, 'entrega em trânsito', 'entregas em trânsito')}.`);
  }
  return { message: parts.join(' ') };
};

export const getRequisicaoStatusHelp = (requisicao) => {
  const status = normalizeRequisicaoStatus(requisicao?.status);
  if (status === 'EXECUTANDO') {
    const atencao = getEntregaAtencao(requisicao);
    if (atencao) return `${atencao.message} Veja a aba Entregas.`;
  }
  return REQUISICAO_STATUS_HELP[status] || '';
};

export const hasEntregaCriada = (requisicao) =>
  (requisicao?.entregas && requisicao.entregas.length > 0)
  || getRequisicaoItems(requisicao).some((item) => item.entregaId);
